import script from "./PageFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageFooter.vue?vue&type=script&setup=true&lang=ts"

import "./PageFooter.vue?vue&type=style&index=0&id=57697474&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57697474"]])

export default __exports__